import { jsx as _jsx } from "react/jsx-runtime";
import { getTemplate, labelValue } from '@rjsf/utils';
export default function RangeWidget(props) {
    const { value, label, hideLabel, options, registry } = props;
    const BaseInputTemplate = getTemplate('BaseInputTemplate', registry, options);
    return (_jsx(BaseInputTemplate, { ...props, extraProps: { label: labelValue(label || undefined, hideLabel) }, children: _jsx("span", { className: 'range-view', children: value }) }));
}
//# sourceMappingURL=RangeWidget.js.map